module.exports = __webpack_public_path__ + "eb2c93e12cdb4b375cf04579c11023b9.png";